import { render, staticRenderFns } from "./CategoryOrganizationsFeedItem.vue?vue&type=template&id=12ea15ab&scoped=true&"
import script from "./CategoryOrganizationsFeedItem.vue?vue&type=script&lang=js&"
export * from "./CategoryOrganizationsFeedItem.vue?vue&type=script&lang=js&"
import style0 from "./CategoryOrganizationsFeedItem.vue?vue&type=style&index=0&id=12ea15ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ea15ab",
  null
  
)

export default component.exports